export const buildQuickFilterOptions = (filterOptions, optionDataMap, optionDataReset = {}) => filterOptions.map(option => Object.assign(
  option,
  { data: option.data?.length && !optionDataReset[option.name] ? option.data : optionDataMap[option.name] || [] }
));

export const setAdvancedFilterValues = (filterOptions, optionsDataMap) => {
  const newFilters = filterOptions.map(option => {
    const matchFilterOption = optionsDataMap[option.name];

    if (matchFilterOption) {
      const updatedSubProperties = option.subProperties.map(property => {
        if (matchFilterOption.subProperty === property.name) {
          return { ...property, values: matchFilterOption.values };
        }

        return property;
      });

      return {
        ...option,
        subProperties: updatedSubProperties
      };
    }

    return option;
  });
  return newFilters;
};
